<template>
    <div>
        <internal-header
            :heading="this.batch.payer"

            :show-button="true"
            :button-link="exportBatch"
            button-text="Export"

            :second-show-button="true"
            :second-button-link="goBack"
            second-button-text="Back to batch list"
        />
        <v-switch
            v-if="this.batch.data_excels_discrepancies.length > 0"
            v-model="filters.discrepancies"
            :label="'Filter Discrepancies ('+this.batch.data_excels_discrepancies.length+')'"
        ></v-switch>

        <smart-table
            id="member_data_excels_list"
            class="row-pointer"
            endpoint="memberdataexcel.list"
            :headers="headers"
            :options_payload="{only_batch_details:true}"
            hide-default-header
            :search="search"
            :multi-sort="true"
            :items-per-page="10"
            item-key="member_data_excels_id"
            :display_fields="displayed_column_names"
            :footer-props="{
                'items-per-page-options': [5, 10, 20, 30]
            }"
            show-expand
            flat
            ref="member_data_excels_list"
        >
            <template v-slot:top="{ item, isMobile, header, index}">

                <div class="data-excel-total tw-flex tw-justify-between px-4 py-4 mb-2">
                    <div class="tw-text-lg">Totals</div>

                    <div class="tw-flex tw-justify-around tw-leading-none tw-w-8/12">
                        <div>
                            <div class="data-excel-info-label">RRSP %</div>
                            <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(totals.pension)) }}</div>
                        </div>
                        <div>
                            <div class="data-excel-info-label">RSP Voluntary</div>
                            <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(totals.pension_deducted_employee)) }}</div>
                        </div>
                        <div>
                            <div class="data-excel-info-label">RRSP $</div>
                            <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(totals.rrsp_daily)) }}</div>
                        </div>
                        <div>
                            <div class="data-excel-info-label">H&W %</div>
                            <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(totals.HW_employer)) }}</div>
                        </div>
                        <div>
                            <div class="data-excel-info-label">H&W $</div>
                            <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(totals.HW_daily)) }}</div>
                        </div>
                        <div>
                            <div class="data-excel-info-label">Admin</div>
                            <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(totals.levy_amount)) }}</div>
                        </div>
                        <div>
                            <div class="data-excel-info-label">Training</div>
                            <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(totals.training_amount)) }}</div>
                        </div>
                        <div>
                            <div class="data-excel-info-label">Dues</div>
                            <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(totals.dues_amount)) }}</div>
                        </div>
                    </div>
                </div>

            </template>

            <template v-slot:item="{ isMobile, item, header, value, index }">
                <v-expansion-panels
                    flat
                    class="px-2 py-1"
                >
                    <v-expansion-panel class="data-excel-panel">
                        <v-expansion-panel-header class="tw-flex tw-flex-col py-0 px-0" hide-actions>
                            <template v-slot:default="{ open }">

                                <div :class="open ? 'data-excel-header-open' : 'data-excel-header-closed'" class="tw-flex tw-justify-between tw-w-full px-4">
                                    <div class="tw-flex tw-items-center tw-text-lg">{{ getUserFullName(item) }}</div>

                                    <div class="tw-underline tw-flex tw-items-center" v-if="open">- Close</div>
                                    <div class="tw-text-secondary tw-underline tw-flex tw-items-center" v-else>+ Expand for details</div>
                                </div>

                                <div v-show="!open" class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-w-full px-4 py-4">

                                    <div class="tw-flex tw-gap-5">
                                        <div>
                                            <div class="data-excel-info-label">Record ID</div>
                                            <div class="tw-text-secondary data-excel-info">{{ item.id }}</div>
                                        </div>
                                        <div>
                                            <div class="data-excel-info-label">Installement/Transfer Date</div>
                                            <div class="tw-text-secondary data-excel-info">{{ item.period_ending }}</div>
                                        </div>
                                        <div>
                                            <div class="data-excel-info-label">Production ID</div>
                                            <div class="tw-text-secondary data-excel-info">{{ item.production?.id }}</div>
                                        </div>
                                        <div>
                                            <div class="data-excel-info-label">Production</div>
                                            <div class="tw-text-secondary data-excel-info">{{ item.production?.name }}</div>
                                        </div>
                                    </div>

                                    <div class="tw-flex tw-gap-5">
                                        <div>
                                            <div class="data-excel-info-label">Days worked</div>
                                            <div class="tw-text-secondary data-excel-info">{{ item.days_worked }}</div>
                                        </div>
                                        <div>
                                            <div class="data-excel-info-label">Hours worked</div>
                                            <div class="tw-text-secondary data-excel-info">{{ item.hours_worked }}</div>
                                        </div>
                                    </div>

                                </div>

                                <div v-show="open" class="tw-flex tw-w-full tw-items-center tw-gap-5 px-4 py-4">
                                    <div>
                                        <div class="data-excel-info-label">Production ID</div>
                                        <div class="tw-text-secondary data-excel-info">{{ item.production?.id }}</div>
                                    </div>
                                    <div>
                                        <div class="data-excel-info-label">Production</div>
                                        <div class="tw-text-secondary data-excel-info">{{ item.production?.name }}</div>
                                    </div>
                                    <div>
                                        <div class="data-excel-info-label">Record ID</div>
                                        <div class="tw-text-secondary data-excel-info">{{ item.id }}</div>
                                    </div>
                                    <div>
                                        <div class="data-excel-info-label">Installement/Transfer Date</div>
                                        <div class="tw-text-secondary data-excel-info">{{ item.period_ending }}</div>
                                    </div>
                                    <div>
                                        <div class="data-excel-info-label">Days worked</div>
                                        <div class="tw-text-secondary data-excel-info">{{ item.days_worked }}</div>
                                    </div>
                                    <div>
                                        <div class="data-excel-info-label">Hours worked</div>
                                        <div class="tw-text-secondary data-excel-info">{{ item.hours_worked }}</div>
                                    </div>
                                    <div>
                                        <div class="data-excel-info-label">Province Lookup</div>
                                        <div class="tw-text-secondary data-excel-info">{{ item.province_lookup || '-' }}</div>
                                    </div>
                                </div>

                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content id="data-excel-panel-content">

                            <div class="tw-flex tw-items-end tw-gap-5 px-4 pb-4 tw-leading-none">
                                <div>
                                    <div class="data-excel-info-label">Dues</div>
                                    <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(item.dues_amount)) }}</div>
                                </div>
                                <div>
                                    <div class="data-excel-info-label">Daily</div>
                                    <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(item.HW_daily)) }}</div>
                                </div>
                                <div>
                                    <div class="data-excel-info-label">Admin</div>
                                    <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(item.levy_amount)) }}</div>
                                </div>
                                <div>
                                    <div class="data-excel-info-label">Training</div>
                                    <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(item.training_amount)) }}</div>
                                </div>
                                <div>
                                    <div class="data-excel-info-label">RRSP Daily</div>
                                    <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(item.rrsp_daily)) }}</div>
                                </div>
                                <div>
                                    <div class="data-excel-info-label">Employer <br>(RRSP 1)</div>
                                    <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(item.pension)) }}</div>
                                </div>
                                <div>
                                    <div class="data-excel-info-label">Employee <br>(RRSP 1 Deducted)</div>
                                    <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(item.pension_deducted)) }}</div>
                                </div>
                                <div>
                                    <div class="data-excel-info-label">Top up <br>(RRSP 2)</div>
                                    <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(item.pension_deducted_employee)) }}</div>
                                </div>
                                <div>
                                    <div class="data-excel-info-label">H&W Employer</div>
                                    <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(item.HW_employer)) }}</div>
                                </div>
                                <div>
                                    <div class="data-excel-info-label">H&W Employee</div>
                                    <div class="tw-text-secondary data-excel-info">{{ $root.formatCurrency(Number(item.HW_employee)) }}</div>
                                </div>
                            </div>

                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </template>
        </smart-table>
    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayout from "@/Layouts/AppLayout.vue";
    import InternalHeader from "@/Generic/InternalHeader";

    export default {
        name: "BatchesShow",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            SmartTable,
            InternalHeader,
        },
        remember: {
            data: [
                'items'
            ]
        },
        props: {
            'inputProp': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'totalsProp': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            }
        },
        data() {
            return {
                search: null,
                exportLoading: false,
                batch: this.inputProp,
                totals: this.totalsProp,
                filters: {
                    batch_id: this.inputProp.id,
                    discrepancies: false,
                },
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'batch_id',                     text: 'batch_id',                    align: `start`, sortable: true,    filterable: true,   search: this?.filters?.batch_id, optional: false, },
                    {value: 'discrepancies',                text: '',                            align: `start`, sortable: true,    filterable: true,   search: this?.filters?.discrepancies, optional: false, },
                    {value: 'data-table-expand',            text: '',                            align: `start`, sortable: true,    filterable: true,   optional: false, },

                ]
            },
            displayed_column_names() {
                let headers_to_display = this.headers.filter(header => this.should_column_be_displayed(header.value))
                return headers_to_display.map(header => header.value)
            },
        },
        methods: {
            should_column_be_displayed(column) {
                let required_headers = ['id', 'data-table-expand']
                return required_headers.includes(column)
            },
            refreshBatchData() {
                this.$refs.member_data_excels_list.refreshList()
            },
            goBack() {
                this.$inertia.visit(route('batches.index'))
            },
            async exportBatch() {
                if (await this.$root.confirm.open(`Export Batch`, `You are about to export Batch #${this.batch.id}`)) {
                    let method = 'post'
                    let url = route('batches.export')
                    let payload = this.batch

                    axios({
                        method: method,
                        url: url,
                        data: payload,
                        onUploadProgress: (evt) => {
                            this.exportLoading = !this.exportLoading
                        },
                        onDownloadProgress: (evt) => {
                            this.exportLoading = !this.exportLoading
                        },
                    })
                        .then(response => {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success(`You will receive an email to ${this.$page.user?.email} with the export once it is done.`)
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.exportLoading = false
                                this.$emit('successful-batch-export')
                            } else {
                                throw (response.data.error)
                            }
                        })
                        .catch((error) => {
                            this.$root.snackbar.error(error.response?.data.message || error)
                            this.exportLoading = false
                        })
                }
            },
            getUserFullName(item) {
                if (item.member?.first_name || item.member?.last_name) {
                    return `${item.member.last_name}, ${item.member.first_name}`
                } else {
                    return `${item.last_name}, ${item.first_name}`
                }
            }
        }
    }
</script>

<style scoped>
.row-pointer tbody tr {
    cursor: pointer;
}

.data-excel-total {
    color: #757575;
    border: 2px solid #505050;
    border-radius: 0 !important;
}

.data-excel-panel {
    border: 1px solid #505050;
    border-radius: 0 !important;
}

.data-excel-header-open {
    color: #505050;
    height: 40px;
    background-color: #E4E4E4;
    border-bottom: 2px solid #505050;
    transition: background-color 100ms;
}

.data-excel-header-closed {
    color: #505050;
    height: 40px;
    background-color: #F7F7F7;
    border-bottom: 2px solid #505050;
    transition: background-color 100ms;
}


.data-excel-header-closed:hover {
    background-color: #E4E4E4;
}

.data-excel-info-label {
    color: #777777;
    font-size: 11px;
    padding-bottom: 2px;
}

.data-excel-info {
    font-size: 15px
}

#data-excel-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 !important;
}

</style>
